var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_476_",
    transform: "translate(26.385 -7.422) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_503_",
    d: "M176.865,14.519a1.258,1.258,0,0,0,0-1.779l-1.888-1.888a1.258,1.258,0,0,0-1.6-.151l-3.97,2.7,2.682-4a1.258,1.258,0,0,0-.155-1.591l-4.1-4.1a1.258,1.258,0,0,0-1.435-.244l-.708.341.339-.752a1.258,1.258,0,0,0-.257-1.407L164.494.369a1.258,1.258,0,0,0-1.779,0l-9.986,9.986,14.15,14.15Z",
    transform: "translate(-142.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1199_",
    d: "M10.95,145.622l-2.891,2.891a1.258,1.258,0,0,0,0,1.779l2.742,2.742a2.451,2.451,0,0,1-.418,3.8c-8.057,5.136-8.808,5.887-9.055,6.134a4.543,4.543,0,0,0,6.425,6.425c.247-.247,1-1,6.134-9.055a2.455,2.455,0,0,1,3.8-.418l2.742,2.742a1.258,1.258,0,0,0,1.779,0l2.891-2.891Zm-5.075,21.74a1.778,1.778,0,1,1,0-2.515A1.778,1.778,0,0,1,5.875,167.362Z",
    transform: "translate(0 -133.408)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.23cccbb6c0197f6ea6009b7bcf88e982.svg";
export { ForwardRef as ReactComponent };